module.exports = {
  mainHead: {
    platList_weibo: "微博",
    platList_douyin: "抖音",
    platList_xhs: "小红书",
    platList_bzhan: "B站",
    platList_kuaishou: "快手",
    platList_weixin: "微信",
    platList_jrtt: "今日头条",
    platList_zhihu: "知乎",
    platList_dewu: "得物",
    platList_hupu: "虎扑",
    cshop: "淘宝",
    "cshop,tmall": "淘宝+天猫",
    "cshop,tmall,jd": "淘宝+天猫+京东",
    "cshop,tmall,douyin": "淘宝+天猫+抖音",
    "cshop,jd": "淘宝+京东",
    "tmall,jd": "天猫+京东",
    global: "淘宝全球购",
    tmall: "天猫",
    tmallhk: "天猫国际",
    chaoshi: "天猫超市",
    tmallhk_gfzy: "天猫国际官方直营",
    nochaoshi: "天猫非天猫超市",
    notmallhk: "天猫非天猫国际",
    tmqjd: "天猫旗舰店",
    tmzyzmd: "天猫专卖专营店",
    jd: "京东",
    jd_only_self: "京东自营",
    jd_exclude_self: "京东非自营",
    jd_hk: "京东全球购",
    jd_home_self: "京东国内自营",
    jd_home_pop: "京东国内POP",
    jd_not_home_self: "京东海外自营",
    jd_not_home_pop: "京东海外POP",
    amazon: "亚马逊",
    amazon_us: "亚马逊美国站",
    amazon_de: "亚马逊德国站",
    amazon_es: "亚马逊西班牙",
    amazon_fr: "亚马逊法国站",
    amazon_it: "亚马逊意大利站",
    amazon_uk: "亚马逊英国站",
    amazon_jp: "亚马逊日本站",
    amazon_ae: "亚马逊阿拉伯联合酋长国站",
    amazon_sa: "亚马逊沙特阿拉伯站",
    amazon_br: "亚马逊巴西站",
    amazon_mx: "亚马逊墨西哥站",
    shopee: "虾皮",
    shopee_vn: "虾皮越南站",
    shopee_th: "虾皮泰国站",
    shopee_sg: "虾皮新加坡站",
    shopee_my: "虾皮马来西亚站",
    shopee_ph: "虾皮菲律宾站",
    shopee_id: "虾皮印尼站",
    shopee_tw: "虾皮中国台湾站",
    lazada: "来赞达",
    lazada_vn: "来赞达越南站",
    lazada_th: "来赞达泰国站",
    lazada_sg: "来赞达新加坡站",
    lazada_my: "来赞达马来西亚站",
    lazada_ph: "来赞达菲律宾站",
    lazada_id: "来赞达印尼站",
  }
}
